import KundenStorage from "../storage/kunden-storage";
import {
  FETCH_ENTRIES,
  FETCH_ENTRY,
  RESET_EDITED_KUNDE,
  EDIT_ENTRY,
  SET_ADRESS_LIST,
  SET_KUNDEN_ID,
  SET_KONTO_SELECTED,
} from "../actions/types/kunden-types";

export default function reducer(state = KundenStorage, action) {
  switch (action.type) {
    case FETCH_ENTRIES: {
      let newState = { ...state };
      newState.setKundenList(action.payload);
      return newState;
    }
    case FETCH_ENTRY: {
      let newState = { ...state };
      newState.setKunde(action.payload);
      return newState;
    }
    case EDIT_ENTRY: {
      let newState = { ...state };
      newState.setEditedKunde(action.payload);
      return newState;
    }
    case SET_ADRESS_LIST: {
      let newState = { ...state };
      newState.setAdressList(action.payload);
      return newState;
    }
    case RESET_EDITED_KUNDE: {
      let newState = { ...state };
      newState.resetEditedKunde();
      return newState;
    }
    case SET_KUNDEN_ID: {
      let newState = { ...state };
      newState.setKundenId(action.payload);
      return newState;
    }
    case SET_KONTO_SELECTED: {
      let newState = { ...state };
      newState.setKontoSelected(action.payload);
      return newState;
    }
    default:
      return state;
  }
};
